import React from "react";
import Sidebar from "./components/Sidebar";
import { Switch, Route, Redirect } from "react-router-dom";
import Featured from "./Featured";
import Users from "./Users";
import UserEdit from "./UserEdit";
import AdminRoles from "./AdminRoles";
import Livestream from "./Livestream";
import Crypto from "./Crypto";
import BannerManagement from "./BannerManagement";
import Reports from "./Reports";
import StreamTransactions from "./StreamTransactions";
import BalanceManagement from "./BalanceManagement";
import Premium from "./Premium";
import FundingSheet from "./FundingSheet";
import { OperationsFundingSheet } from "./FundingSheet";
import BulkAlbumUpload from "./BulkAlbumUpload";
import "./Admin.scss";
import cookieStorage from "../../services/cookie-storage";

export default function AdminPortal() {
    console.log("AdminPortal is rendering");
    const userString = localStorage.getItem("userData");
    const userData = userString ? JSON.parse(userString) : null;
    const user = userData?.userData || userData || null;
    
    console.log('Raw localStorage userData:', userString);
    console.log('Parsed userData:', userData);
    console.log('Final user object:', user);
    console.log('User email:', user?.email);
    
  return (
    <div className="adminLayout">
      <Sidebar user={user} />
      <main className="adminMain">
        <Switch>
          <Route path="/admin/featured" component={Featured} />
          <Route path="/admin/users" exact component={Users} />
          <Route path="/admin/user/:userId/edit" component={UserEdit} />
          <Route path="/admin/roles" component={AdminRoles} />
          <Route path="/admin/livestream" component={Livestream} />
          <Route path="/admin/crypto" component={Crypto} />
          <Route path="/admin/banners" component={BannerManagement} />
          <Route path="/admin/reports" component={Reports} />
          <Route path="/admin/stream-transactions" component={StreamTransactions} />
          <Route 
            path="/admin/balance" 
            render={(props) => <BalanceManagement {...props} user={user} />} 
          />
          <Route 
            path="/admin/funding" 
            render={(props) => <FundingSheet {...props} user={user} />} 
          />
          <Route 
            path="/admin/operations-funding" 
            render={(props) => <OperationsFundingSheet {...props} user={user} />} 
          />
          <Route 
            path="/admin/public-funding" 
            render={(props) => {
              // Check for token in URL
              const urlParams = new URLSearchParams(window.location.search);
              const token = urlParams.get('token');
              
              if (token === 'siki-investor-2024') {
                return <FundingSheet {...props} user={user} isPublic={true} />;
              }
              
              // Redirect if no valid token
              window.location.href = '/';
              return null;
            }} 
          />
          <Route path="/admin/premium" component={Premium} />
          <Route path="/admin/bulk-album-upload" component={BulkAlbumUpload} />
          <Redirect to="/admin/featured" />
        </Switch>
      </main>
    </div>
  );
}